import { DynamicConfig } from '@statsig/js-client';

import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { StatsigService } from '@services/statsig.service';

enum PheonixMigrationComponents {
  SINGLE_SELECT_FILTER = 'single-select-filter',
  MULTI_SELECT_FILTER = 'multi-select-filter',
  DATE_RANGE_FILTER = 'date-range-filter',
  DATE_PICKER = 'date-picker',
  TOGGLE_FILTER = 'toggle-filter',
  SEARCH_FILTER = 'search-filter',
  REPORT_SWITCHER_FILTER = 'report-switcher-filter',
  SAVE_MODAL = 'save-modal',
  TAG_CELL = 'tag-cell',
}

type ReportsPhxMigrationConfigType = {
  [key in PheonixMigrationComponents]: boolean
};

type ReportsPhxMigrationConfigPerRouteType = {
  [key: string]: ReportsPhxMigrationConfigType;
} | {};

// dynamic config from statsig
export const CONFIG_NAME = 'reports-phx-migration';

@Injectable({ providedIn: 'root' })
export class ReportsPhxMigrationConfig {
  private config: DynamicConfig;

  constructor(
    private statsigService: StatsigService,
    private location: Location,
  ) {
    this.config = this.statsigService.evaluateDynamicConfig(CONFIG_NAME);
  }

  public get getConfig(): ReportsPhxMigrationConfigType {
    const configValue: ReportsPhxMigrationConfigPerRouteType | ReportsPhxMigrationConfigType = this.config.value;
    return configValue['default'] as ReportsPhxMigrationConfigType ?? configValue as ReportsPhxMigrationConfigType;
  }

  public isToggleFilterPhxMigrationEnabled(): boolean {
    return this.getConfig?.[PheonixMigrationComponents.TOGGLE_FILTER] ?? false;
  }

  public isReportSwitcherPhxMigrationEnabled(): boolean {
    return this.getConfig?.[PheonixMigrationComponents.REPORT_SWITCHER_FILTER] ?? false;
  }

  public isSearchFilterPhxMigrationEnabled(): boolean {
    return this.getConfig?.[PheonixMigrationComponents.SEARCH_FILTER] ?? false;
  }

  public isSingleSelectFilterPhxMigrationEnabled(): boolean {
    return this.getConfig?.[PheonixMigrationComponents.SINGLE_SELECT_FILTER] ?? false;
  }

  public isMultiSelectFilterPhxMigrationEnabled(): boolean {
    return this.getConfig?.[PheonixMigrationComponents.MULTI_SELECT_FILTER] ?? false;
  }

  public isDateRangeFilterPhxMigrationEnabled(reportLink?: string): boolean {
    let reportRoutekey: string;
    if (reportLink) {
      reportRoutekey = Object.keys(this.config.value).find(key => reportLink.indexOf(key) !== -1) || 'default';
    } else {
      reportRoutekey = Object.keys(this.config.value).find(key => this.location.path().indexOf(key) !== -1) || 'default';
    }
    // this.config.value[PheonixMigrationComponents.DATE_RANGE_FILTER] is for backward compatibility for statsic config
    return this.config.value[reportRoutekey]?.[PheonixMigrationComponents.DATE_RANGE_FILTER]
      ?? this.config.value[PheonixMigrationComponents.DATE_RANGE_FILTER];
  }

  public isDatePickerPhxMigrationEnabled(): boolean {
    return this.getConfig?.[PheonixMigrationComponents.DATE_PICKER] ?? false;
  }

  public isTagCellPhxMigrationEnabled(): boolean {
    return this.getConfig[PheonixMigrationComponents.TAG_CELL];
  }

  public isSaveModalPhxMigrationEnabled(): boolean {
    return this.getConfig[PheonixMigrationComponents.SAVE_MODAL];
  }
}